var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUsdce24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 24a12 12 0 1 0 -12-12 11.971 11.971 0 0 0 12 12z",
    fill: "#2775ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m723.53 516.316c0-1.792-1.075-2.406-3.225-2.662-1.536-.2-1.843-.614-1.843-1.331s.512-1.177 1.536-1.177a1.515 1.515 0 0 1 1.689 1.075.385.385 0 0 0 .358.256h.819a.35.35 0 0 0 .358-.358v-.051a2.558 2.558 0 0 0 -2.3-2.1v-1.228c0-.2-.154-.358-.41-.41h-.768c-.2 0-.358.154-.41.41v1.177a2.61 2.61 0 0 0 -2.508 2.508c0 1.689 1.024 2.355 3.174 2.611 1.433.256 1.894.563 1.894 1.382s-.717 1.382-1.689 1.382c-1.331 0-1.792-.563-1.945-1.331a.374.374 0 0 0 -.358-.307h-.87a.35.35 0 0 0 -.358.358v.051a2.859 2.859 0 0 0 2.713 2.457v1.229c0 .2.154.358.41.409h.768c.2 0 .358-.154.41-.409v-1.229a2.8 2.8 0 0 0 2.56-2.713z",
    transform: "translate(-708.149 -502.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.389 307.175a7.41 7.41 0 0 1 0-13.92.5.5 0 0 0 .3-.5v-.694a.377.377 0 0 0 -.3-.4.3.3 0 0 0 -.2.049 8.911 8.911 0 0 0 0 16.992.3.3 0 0 0 .446-.2c.05-.049.05-.1.05-.2v-.694a.66.66 0 0 0 -.296-.433zm5.258-15.456a.3.3 0 0 0 -.446.2c-.05.05-.05.1-.05.2v.693a.657.657 0 0 0 .3.5 7.41 7.41 0 0 1 0 13.92.5.5 0 0 0 -.3.5v.693a.377.377 0 0 0 .3.4.3.3 0 0 0 .2-.049 8.9 8.9 0 0 0 5.8-11.2 8.991 8.991 0 0 0 -5.804-5.857z",
    transform: "translate(-244.919 -288.086)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsdce24);
export default __webpack_public_path__ + "static/media/ic_usdc.e_24.0952740b304973b743a89e5294f8acd5.svg";
export { ForwardRef as ReactComponent };